export enum FormTypes {

    Hubspot = 'hubspot',
    Stripe = 'stripe',
    Paypal = 'paypal',
    Stripe_Google_Pay = 'stripe_google_pay',
    Stripe_Apple_Pay = 'stripe_apple_pay',
    Stripe_Ach = 'stripe_ach',
    Stripe_Bacs = 'stripe_bacs',
    Custom = 'custom',
    Subscription = 'Subscription',
    Product = 'Product',
    DynamicSubscription = 'dynamicSubscription',
    DonationForm = 'donationForm',
    Discount = 'discount',
    Quantity = 'quantity',
    Addon = 'addon',
    AdaptivePrices = 'adaptivePrices',
    AdaptiveSubscriptionPrices = 'adaptiveSubscriptionPrices',
    MultipleContacts = 'multipleContacts',
    RecaptchaV3 = 'recaptchaV3',
    RecaptchaV2 = 'recaptchaV2',
    Tax = 'tax',
    OfflinePayment = 'offline_payment',
    LogFailingOnInit = 'logFailingOnInit',
    LogFailingOnRender = 'logFailingOnRender',
    UpSell = 'upSell',
    UpSellProduct = 'upSellProduct',
    UpSellSubscription = 'upSellSubscription',
    UpSellDonation = 'upSellDonation',
    CountdownTimer = 'countdownTimer',
    FacebookPixel = 'facebookPixel',
    GoogleAnalytics = 'googleAnalytics'

}
